import Glide from "@glidejs/glide";

(($) => {
  $(document).ready(function () {
    // MENU MOBILE
    $("#menu-mobile-trigger").click(function () {
      $("#menu-mobile").toggleClass("open");
      $(this).toggleClass("open");

      // Toggle overlay class based on the state of both menus
      if ($("#menu-mobile").hasClass("open") || $(".menu-artefact.compact").hasClass("open")) {
        $("body").addClass("overlay-active");
      } else {
        $("body").removeClass("overlay-active");
      }

      // Close the artefact menu if it's open
      if ($("#menu-mobile").hasClass("open")) {
        $("#menu-artefact-trigger").removeClass("open");
        $(".menu-artefact.compact").removeClass("open");
      }

      if ($(window).scrollTop() > 0) {
        if ($("#menu-mobile").hasClass("open")) {
          $("#menu-artefact-trigger").removeClass("scroll");
        } else {
          if (!$(".menu-artefact.compact").hasClass("open"))
            $("#menu-artefact-trigger").addClass("scroll");
        }
      }
    });

    // MENU SUB-MENU
    $("#menu-mobile .menu-item.menu-item-has-children").click(function () {
      $(this).toggleClass("open");
    });

    // MENU ARTEFACT
    $("#menu-artefact-trigger").click(function () {
      const artefactMenu = $(".menu-artefact.compact");
      artefactMenu.toggleClass("open");
      $(this).toggleClass("open");

      // Toggle overlay class based on the state of both menus
      if (artefactMenu.hasClass("open") || $("#menu-mobile").hasClass("open")) {
        $("body").addClass("overlay-active");
      } else {
        $("body").removeClass("overlay-active");
      }

      // Close the mobile menu if it's open
      if (artefactMenu.hasClass("open")) {
        $("#menu-mobile-trigger").removeClass("open");
        $("#menu-mobile").removeClass("open");
      }
    });

    // Close Artefact menu when search input is clicked
    $("#search-input").on("focus", function () {
      if ($(".menu-artefact.compact").hasClass("open")) {
        $(".menu-artefact.compact").removeClass("open");
        $("#menu-artefact-trigger").removeClass("open");
        $("body").removeClass("overlay-active");
      }
      if ($("#menu-mobile").hasClass("open")) {
        $("#menu-mobile").removeClass("open");
        $("#menu-mobile-trigger").removeClass("open");
        $("body").removeClass("overlay-active");
      }
    });

    // SCROLL EVENTS
    $(window).on("scroll", function () {
      if($(this).scrollTop() < $('#single-header').height()){
        $('#sticky-btn-event').removeClass('show');
      }else{
        $('#sticky-btn-event').addClass('show');
      }
    });

    // let lastScrollTop = 0;
    // $(window).on("scroll", function () {
    //   let currentScrollTop = $(this).scrollTop();

    //   // SCROLLING DOWN
    //   if (currentScrollTop > lastScrollTop) {
    //     if ($(this).width() < 1280) {
    //       // ONLY IF NOT OPENED MENUS
    //       if (
    //         !$("#menu-artefact-trigger").hasClass("open") &&
    //         !$("#menu-mobile").hasClass("open")
    //       ) {
    //         $("#menu-artefact-trigger").addClass("scroll");
    //       }
    //     } else {
    //       $(".menu-artefact.compact").addClass("scroll");
    //     }
    //   } else {
    //     if ($(this).width() < 1280) {
    //       // ONLY IF NOT OPENED MENUS
    //       if (
    //         !$("#menu-artefact-trigger").hasClass("open") &&
    //         !$("#menu-mobile").hasClass("open")
    //       ) {
    //         $("#menu-artefact-trigger").removeClass("scroll");
    //       }
    //     } else {
    //       $(".menu-artefact.compact").removeClass("scroll");
    //     }
    //   }

    //   // Ensure the menu remains visible at the top of the page on iOS
    //   if (currentScrollTop === 0) {
    //     $("#menu-artefact-trigger").removeClass("scroll");
    //     $(".menu-artefact.compact").removeClass("scroll");
    //   }

    //   // UPDATE SCROLL TOP VALUE
    //   lastScrollTop = currentScrollTop;
    // });

    //SEARCH
    function toggleSearch() {
      $("#search").toggleClass("open");
      $("#searchform").stop().slideToggle(300);
      if ($("#search").hasClass("open")) {
        $('#searchform input[type="search"]').focus();
      }
    }

    $(document).keydown(function (event) {
      if (event.ctrlKey && event.key === "k") {
        event.preventDefault();
        toggleSearch();
      }
    });
    $("#search").click(toggleSearch);

    //MODAL
    $(".cd-modal-trigger").click(function (e) {
      e.preventDefault();
      var content = $(this).find(".modal--content").html();
      openModal(content);
    });
    $(".modal--bg, #modal .close").click(function () {
      closeModal();
    });
    function openModal(content) {
      $("#modal").find(".container").append(content);
      $(".modal--container").addClass("show");
      $("html, body").addClass("overflow-hidden");
    }
    function closeModal() {
      $(".modal--container").removeClass("show");
      $("html, body").removeClass("overflow-hidden");
      setTimeout(function () {
        $("#modal").find(".container").empty();
      }, 300);
    }

    // LIGHTGALLERY
    $(".lightgallery")
      .lightGallery({
        download: false,
        selector: "a",
      })
      .on("onBeforeSlide.lg", function () {
        $(".lg-backdrop").css("opacity", "0.8");
        $(".lg-sub-html").css("opacity", "0");
      });

    // TEXT FIT
    function resizeText() {
      textFit($(".text-fit, .custom-title"), {
        alignHoriz: true,
        maxFontSize: 230,
        minFontSize: 18,
        widthOnly: true,
      });
    }
    $(window).on("resize", resizeText);
    resizeText();
  });

  // Toggle search modal
  $("#search-trigger").on("click", function () {
    $(".search-modal").removeClass("hidden");
    $("#search-input").val("").focus(); // Clear and focus on the search input
    $("#autocomplete-results").hide(); // Hide autocomplete results
  });

  $("#close-search").on("click", function () {
    $(".search-modal").addClass("hidden");
  });

  // Autocomplete functionality
  $("#search-input").on("input", function () {
    const query = $(this).val();
    const entity =
      typeof entityData.slug !== "undefined" ? entityData.slug : ""; // Get the entity from localized data

    if (query.length > 2) {
      $.ajax({
        url: ajax.url, // WordPress AJAX URL
        method: "POST",
        data: {
          action: "fetch_autocomplete_results",
          query: query,
          entity: entity, // Pass the entity slug
        },
        beforeSend: function () {
          $("#autocomplete-results")
            .html('<p class="p-4 text-center text-gray-500">Chargement...</p>')
            .show();
        },
        success: function (response) {
          $("#autocomplete-results").html(response).show();
        },
        error: function () {
          $("#autocomplete-results")
            .html(
            )
            .show();
        },
      });
    } else {
      $("#autocomplete-results").hide();
    }
  });

  // Close autocomplete results and search modal when clicking outside
  $(document).on("click", function (e) {
    if (
      !$(e.target).closest(".search-modal").length &&
      !$(e.target).closest("#search-trigger").length
    ) {
      $(".search-modal").addClass("hidden");
      $("#autocomplete-results").addClass("hidden");
    }
  });

  // Add .scroll class to search-container on scroll
  let lastScrollTop = 0;
  $(window).on("scroll", function () {
    let scrollTop = $(this).scrollTop();
    if (scrollTop > lastScrollTop) {
      // Scrolling down
      $(".search-container").addClass("scroll");
    } else {
      // Scrolling up
      $(".search-container").removeClass("scroll");
    }
    lastScrollTop = scrollTop;
  });

  $(".entity-filter a").on("click", function (e) {
    e.preventDefault();

    let newUrl = new URL($(this).attr("href"), window.location.origin);
    newUrl.searchParams.delete("paged"); // Remove pagination when switching entities

    window.location.href = newUrl.toString(); // Navigate to the new URL
  });

  const accordions = $(".wp-block-data-theme-accordion");

  accordions.each(function () {
    const label = $(this).find(".accordion--label");
    const content = $(this).find(".accordion--content");

    label.on("click", function () {
      $(this).toggleClass("active");
      content.slideToggle(300).toggleClass("hidden active");
      $(this).closest(".wp-block-data-theme-accordion").toggleClass("active");
    });
  });

  const glide = new Glide(".glide", {
    type: "carousel",
    perView: 3.02,
    touchAngle: 0,
    breakpoints: {
      1103: {
        touchAngle: 45,
        autoplay: 4000,
        perView: 2.02,
        focusAt: "center",
      },
      506: {
        touchAngle: 45,
        autoplay: 4000,
        perView: 1.03,
        focusAt: "center",
        peek: {
          before: 20,
          after: 20,
        },
      },
    },
  });

  glide.mount();
})(jQuery);
